import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Trophy } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";
import { RhythmLeaderboard } from "@/components/RhythmLeaderboard";
import { QuizStreakBoard, StreakBoard } from "@/components/QuizStreakBoard";

export default function HallOfFame() {
  const [weeks, setWeeks] = useState(null);
  useEffect(() => { api.get("/champions/hall-of-fame").then(({ data }) => setWeeks(data.weeks)).catch(() => setWeeks([])); }, []);
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <div className="mx-auto max-w-5xl px-4 sm:px-8 py-12" data-testid="hall-of-fame">
        <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-primary"><Trophy size={14} /> Leaderboard</p>
        <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">Every weekly champion</h1>
        <p className="mt-3 max-w-2xl text-muted-foreground">Students who finished a week at #1 on the Melody Ear Trainer or Sight-Reading Trainer leaderboards. Your name stays here for good. Weekly Rhythm Challenge winners are crowned Rhythm Champion every Monday — plus this week's Rhythm Clap top 10.</p>
        <div className="mt-4 flex gap-3 text-sm">
          <Link to="/ear-trainer" className="text-primary hover:underline" data-testid="hof-ear-link">Melody Ear Trainer →</Link>
          <Link to="/trainer" className="text-primary hover:underline" data-testid="hof-trainer-link">Sight-Reading Trainer →</Link>
          <Link to="/rhythm-clap" className="text-primary hover:underline" data-testid="hof-rhythm-link">Rhythm Clap →</Link>
        </div>
        <RhythmLeaderboard testId="hof-rhythm-leaderboard" showLink />
        <QuizStreakBoard />
        <StreakBoard kind="practice" />
        <StreakBoard kind="game" />
        <StreakBoard kind="gotw" />
        {weeks === null ? <p className="mt-10 text-muted-foreground">Loading…</p> : weeks.length === 0 ? (
          <p className="mt-10 rounded-2xl border border-dashed border-border p-8 text-center text-muted-foreground" data-testid="hof-empty">No champions yet — the first weekly winners will appear here next Monday.</p>
        ) : (
          <div className="mt-10 space-y-8">
            {weeks.map((w) => (
              <section key={w.week} data-testid={`hof-week-${w.week}`}>
                <h2 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{w.week}</h2>
                <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                  {w.champions.map((c) => (
                    <div key={`${c.board}-${c.level}`} className="rounded-2xl border border-primary/30 bg-card p-4" data-testid={c.board === "Rhythm Champion" ? `hof-rhythm-champion-${w.week}` : undefined}>
                      <Crown size={18} className="text-primary" />
                      <p className="mt-2 font-serif text-lg">{c.name}</p>
                      <p className="text-xs text-muted-foreground">{c.board} · {c.level}</p>
                      <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-primary">{c.board === "Rhythm Champion" ? `Score ${c.score}%` : `Streak ${c.streak}`}</p>
                    </div>
                  ))}
                </div>
              </section>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
